import React from "react";

const FilterAndValue = (props: React.PropsWithChildren<unknown>) => {
  return <div className="flex-column gap-mini">
    {props.children}
  </div>
}

export default FilterAndValue;